module.exports = require('./lib/clean');



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/index.js
// module id = 987
// module chunks = 0